"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Rating_1 = __importDefault(require("@material-ui/lab/Rating"));
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_redux_1 = require("react-redux");
var icons_1 = require("../../../../common/icons");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var activityService_1 = require("../../../../app/services/activityService");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        root: {
            margin: theme.spacing(1, 0),
        },
        item: {
            maxHeight: 1000,
            marginBottom: theme.spacing(2),
            padding: theme.spacing(1),
            '$white &': {
                marginBottom: theme.spacing(3),
                padding: 0,
            },
        },
        hiddenWhenRated: {
            opacity: 0,
            margin: 0,
            padding: 0,
            maxHeight: 0,
            transition: 'all 0.5s linear',
        },
        itemContent: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.common.white,
            padding: theme.spacing(1),
            minHeight: 50,
            '$white &': {
                backgroundColor: theme.palette.common.white,
            },
        },
        dateLabel: {
            display: 'block',
            marginBottom: theme.spacing(0.5),
            '&:first-letter': {
                textTransform: 'capitalize',
            },
        },
        white: {},
        notCompletedIcon: {
            color: theme.palette.error.main,
        },
        activityText: {
            flex: '1 1 auto',
        },
        editIcon: {
            marginLeft: theme.spacing(1),
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            border: theme.youwell.borders.dotted,
            padding: theme.spacing(0, 1),
        },
        registerLabel: (_a = {
                marginRight: theme.spacing(1)
            },
            _a[theme.breakpoints.down('xs')] = {
                display: 'none',
            },
            _a),
        ratingEffortTitle: {
            padding: theme.spacing(1),
            fontSize: 18,
        },
    });
}, { name: 'ActivityTable' });
var ActivityTable = function (_a) {
    var _b;
    var data = _a.data, onEditClick = _a.onEditClick, white = _a.white, showRating = _a.showRating;
    var dispatch = (0, react_redux_1.useDispatch)();
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    if (!data) {
        return null;
    }
    var editActivity = function (activity) { return function () {
        if (onEditClick) {
            onEditClick(activity);
        }
    }; };
    var handleRatingChange = function (activity, rating) {
        if (rating === null) {
            return;
        }
        var updatedActivity = __assign(__assign({}, activity), { effortRating: rating });
        (0, activityService_1.updateActivitiesData)(dispatch, updatedActivity);
    };
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.root, (_b = {}, _b[classes.white] = white, _b)) }, data.map(function (activity) {
        var _a;
        return (React.createElement("div", { key: activity.id, className: (0, classnames_1.default)(classes.item, (_a = {}, _a[classes.hiddenWhenRated] = activity.isRated, _a)) },
            React.createElement(core_1.Typography, { color: "primary", variant: "caption", className: classes.dateLabel }, (0, dateUtils_1.shortDate)(activity.date, translate, false, true)),
            React.createElement("div", { className: classes.itemContent },
                React.createElement("div", { className: classes.activityText },
                    React.createElement(core_1.Typography, { variant: "subtitle2" }, activity.activity),
                    React.createElement(core_1.Typography, { variant: "body2", color: "textSecondary" }, (0, dateUtils_1.hourCount)(activity.durationInMinutes, translate))),
                React.createElement(core_1.IconButton, { className: classes.editIcon, onClick: editActivity(activity) },
                    React.createElement(icons_1.EditIcon, null))),
            showRating && (React.createElement("div", { className: classes.actions },
                React.createElement(core_1.Typography, { variant: "caption", color: "primary", className: classes.registerLabel }, "".concat(translate('activityDiary.effort'), ": ")),
                React.createElement(core_1.Tooltip, { title: translate('activityDiary.notCompleted'), placement: "top" },
                    React.createElement(core_1.IconButton, { className: classes.notCompletedIcon, onClick: function () { return handleRatingChange(activity, -1); } },
                        React.createElement(icons_1.NotInterestedIcon, null))),
                React.createElement(Rating_1.default, { name: "effortRating-".concat(activity.id), onChange: function (e, r) { return handleRatingChange(activity, r); }, value: activity.effortRating || 0, color: "primary" })))));
    })));
};
ActivityTable.defaultProps = {
    data: null,
    onEditClick: null,
    white: false,
    showRating: false,
};
exports.default = ActivityTable;
